var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutcomesMonitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51,0H5C2.24,0,0,2.24,0,5V51c0,2.76,2.24,5,5,5H51c2.76,0,5-2.24,5-5V5c0-2.76-2.24-5-5-5Zm3,51c0,1.65-1.35,3-3,3H5c-1.65,0-3-1.35-3-3V5c0-1.65,1.35-3,3-3H51c1.65,0,3,1.35,3,3V51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.21,42.21H13.79V12.79c0-.55-.45-1-1-1s-1,.45-1,1v30.42c0,.55,.45,1,1,1h30.42c.55,0,1-.45,1-1s-.45-1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.07,36.97s.1,0,.15-.01c.17-.03,4.14-.64,8.77-3.48,3.88-2.37,8.89-6.78,11.81-14.55l1.52,3.44c.17,.37,.53,.6,.92,.6,.13,0,.27-.03,.4-.08,.5-.22,.73-.81,.51-1.32l-2.55-5.79s-.03-.04-.04-.06c-.01-.02-.03-.04-.05-.07-.05-.08-.11-.16-.19-.23-.03-.02-.06-.04-.09-.06-.06-.04-.12-.09-.19-.12-.02,0-.04,0-.06-.01-.01,0-.02-.01-.03-.02-.04-.01-.08,0-.13-.01-.07-.01-.14-.02-.21-.02-.08,0-.16,.03-.23,.05-.03,.01-.07,0-.1,.02l-.08,.04s0,0,0,0l-5.7,2.52c-.5,.22-.73,.81-.51,1.32,.22,.5,.81,.73,1.32,.51l3.72-1.64c-5.37,14.7-18.51,16.88-19.09,16.97-.54,.08-.92,.59-.84,1.14,.08,.5,.5,.85,.99,.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcomesMonitor);
export default __webpack_public_path__ + "static/media/outcomes-monitor.3c28b601c17a8f50e5243811f62d1975.svg";
export { ForwardRef as ReactComponent };